import React from 'react';
import { useSelector } from 'react-redux';
import Cart from './Cart';
import DirectSaleCart from './DirectSaleCart';
import { ShopMode } from '../../redux/types';

export const CartWrapper: React.FC = () => {
  const shopMode = useSelector((state: any) => state.shopMode.mode);

  return shopMode === ShopMode.DirectSale ? <DirectSaleCart /> : <Cart />;
};
